import React from 'react';
import { FieldType } from './field.types';
import ReactMarkdown from 'react-markdown';

export const InfoField: React.FC<FieldType> = ({ fieldKey, description }) => {
  return (
    <ReactMarkdown key={fieldKey} className="field-info-text">
      {description ?? ''}
    </ReactMarkdown>
  );
};
